<template>
    <div class="bg-white m-6 p-12 rounded-lg flex flex-col justify-start items-center gap-8">
    <img :src="createdImgRef" alt="Registration Complete" class="w-48 h-48 mx-auto">
    <div class="flex flex-col gap-4 py-8 text-center">
      <h1 class="font-bold text-2xl">チャンネル登録が完了しました！</h1>
      <p class="text-sm">
        YouTubeチャンネル情報の登録が完了しました。<br>
        動画管理画面から動画をアップロードして文字起こし記事を作成してください。
      </p>
      <p class="text-xs text-sub">
        <router-link to="/channel-management" class="link-styles">
          ※チャンネル管理ページ
        </router-link>
        から登録した情報の確認・編集ができます。
      </p>
    </div>
    <div class="flex">
      <router-link to="/video-management" class="btn-secondary btn-lg w-full text-center">動画管理ページへ</router-link>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import createdImg from '@/assets/accountcreated.png';

const createdImgRef = ref(createdImg);
</script>
